import styled from 'styled-components';

const StyledConnection = styled.section`
    text-align: center;

    p {
        font-size: 16px;
        font-weight: 400;
        line-height: 28px;
        letter-spacing: -0.02em;
    }

    b {
        display: block;
        margin-bottom: 20px;
    }

    .btn {
        margin-bottom: 40px;
    }
`;

export default StyledConnection;
